import { isEmptyOrWhitespace, styled } from "@shoothill/core";
import { useObserver } from "mobx-react-lite";
import React, { useState } from "react";
import { InductionAdminViewModel } from "../InductionAdminViewModel";
import MaterialTable from "material-table";
import { DarwinTablePageContent } from "Globals/Styles/AppStyling";
import { formatDate, formatTime } from "Utils/Format";
import { SHBox } from "Components/Box";
import { PatchedPagination } from "Components/Table/PatchedPagination";
import * as Defaults from "Globals/Defaults/TableOptions";
import { InductionAdminNonConformanceListModel } from "./InductionAdminNonConformanceListModel";

interface IProps {
    className?: string;
    data: InductionAdminNonConformanceListModel[];
    handleRowClick: (e: any, rowData: InductionAdminNonConformanceListModel) => void;
    isLoading: boolean;
}

const InductionAdminNonConformanceTableViewBase: React.FC<IProps> = (props) => {
    const { data, isLoading, handleRowClick } = props;

    const renderPage = () => {
        return (
            <DarwinTablePageContent>
                <MaterialTable
                    columns={[
                        { title: "Conformance type", field: "nonConformanceTypeName" },
                        {
                            title: "Reference No.",
                            field: "nonConformanceNumber",
                            render: (rowData: InductionAdminNonConformanceListModel) => (
                                <SHBox>
                                    <SHBox>{`CDG-${rowData.referenceNumber(rowData.nonConformanceNumber)}`}</SHBox>
                                </SHBox>
                            ),
                        },
                        {
                            title: "Last updated",
                            field: "lastUpdatedDate",
                            render: (rowData: InductionAdminNonConformanceListModel) => (
                                <SHBox>
                                    <SHBox>
                                        {rowData.lastUpdatedDate !== "" ? formatDate(rowData.lastUpdatedDate) : "-"} @
                                        {rowData.lastUpdatedDate !== "" ? formatTime(rowData.lastUpdatedDate) : "-"}
                                    </SHBox>
                                    <SHBox>{rowData.lastUpdatedByUserName ? `by ${rowData.lastUpdatedByUserName} ` : ""}</SHBox>
                                </SHBox>
                            ),
                            defaultSort: "desc",
                        },
                    ]}
                    components={{
                        Pagination: PatchedPagination,
                    }}
                    options={Defaults.GetDarwinTableOptions()}
                    data={data}
                    onRowClick={(e, rowData) => {
                        handleRowClick(e, rowData!);
                    }}
                    title=""
                    isLoading={isLoading}
                />
            </DarwinTablePageContent>
        );
    };

    return useObserver(() => renderPage());
};

export const InductionAdminNonConformanceTableView = styled(InductionAdminNonConformanceTableViewBase)``;
